<div [ngSwitch]="data.messageType" class="centrado">
    <mat-icon *ngSwitchCase="messageTypeValue.Error" color="warn">warning</mat-icon>
 
    <!-- <some-element *ngSwitchDefault>...</some-element> -->
    <span class="message">{{data.message}}</span>
</div>


